export default "__VITE_ASSET__EMLdixL4__"